import TravelerInfo from "../TravelerInfo";

const StepFour = ({
  quoteData,
  coverOption,
  isSubmitting,
  handleTraveler,
  defaultTourOperatorName,
}) => (
  <TravelerInfo
    embedded
    data={quoteData}
    coverType={coverOption}
    isSubmitting={isSubmitting}
    handleTraveler={handleTraveler}
    defaultTourOperatorName={defaultTourOperatorName}
  />
);

export default StepFour;
